export const blackMonday = {
  id: "black-monday",
  disciplines: "Editorial, Poster",
  year: 2024,
  project: "Wall Street",
  initiatedAt: "FH Salzburg, Austria (Master)",
  shortInitiatedAt: "FHS, AT (MA)",
  thumbnailUrl: "/assets/Black_Monday/00-WS-1x1-1440-Thumbnail.webp",
  description:
    '"Wall Street" is an editorial publication that narrates the buildup to the Black Monday stock market crash typographically. As speculation intensifies, layouts shift from order and legibility toward density, fragmentation, and loss of clarity, culminating in a moment of visual collapse before reassembling and questioning whether the cycle repeats.',
  credits: [
    "Initiated at MA Communication Design, FH Salzburg, AT",
    "Mentoring Julia Otterbach",
  ],
  galleryItems: [
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/01-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Black_Monday/02-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/03-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Black_Monday/04-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/05-WS-1x1-1400.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-four-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Black_Monday/06-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-six-lg span-seven-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/07-WS-16x9.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/08-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "video",
          sound: true,
          url: "/assets/Black_Monday/09-WS-9x10-1440-Video.mp4",
          poster: "/assets/Black_Monday/09-WS-9x10-1440-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg portrait-media-nine-by-ten",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "video",
          sound: true,
          url: "/assets/Black_Monday/10-WS-9x10-1440-Video.mp4",
          poster: "/assets/Black_Monday/10-WS-9x10-1440-Video_thumbnail.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Black_Monday/11-WS-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-eight-lg span-five-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/12-WS-16x9-1400.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-twelve-lg landscape-media-sixteen-by-nine",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/13-WS-9x10-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg portrait-media-nine-by-ten",
        },
        {
          type: "image",
          url: "/assets/Black_Monday/14-WS-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-eight-lg span-five-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames: "start-one-sm span-four-sm start-one-lg span-twelve-lg",
      },
    },
    {
      medias: [
        {
          type: "image",
          url: "/assets/Black_Monday/15-WS-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-one-lg span-six-lg square-media-one-by-one",
        },
        {
          type: "image",
          url: "/assets/Black_Monday/16-WS-1x1-1440.webp",
          classNames:
            "start-one-sm span-four-sm start-seven-lg span-six-lg square-media-one-by-one",
        },
      ],
      description: {
        text: "",
        classNames:
          "start-one-sm span-four-sm start-one-lg span-twelve-lg spacing-bottom",
      },
    },
  ],
};
